<div class="setup-container">
  <div class="content">
    <img
      src="assets/images/kiosk-deskbird-logo.svg"
      alt="Deskbird Logo"
      class="logo"
    />
    <h1 class="title" i18n="@@setup|title">
      Tap the button below to set up kiosk mode
    </h1>

    <button
      (click)="initiateSetup()"
      class="activate-button"
      i18n="@@setup|activate"
    >
      Activate kiosk
    </button>
  </div>

  <div class="help-text">
    <span i18n="@@setup|help">Need help? Go to</span>
    <a [href]="kioskHelpLink" target="_blank" class="help-link"
      >help.deskbird.com</a
    >
  </div>
</div>
